import {
  APPEAL_LOGOUT,
  APPEAL_LOADED,
  APPEAL_NOT_LOADED,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  REGISTER_PENDING,
  UPDATE_SUCCESS,
  UPDATE_PENDING,
  UPDATE_FAIL,
  DANDS_SUCCESS,
  DANDS_PENDING,
  DANDS_FAIL,
  LOGIN_PENDING,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  FILE_UPLOAD_SUCCESS,
  FILE_UPLOAD_PENDING,
  FILE_UPLOAD_FAIL,
  CREATE_REPLY_SUCCESS,
  CREATE_REPLY_PENDING,
  NEW_TOKEN,
  GET_REASONS_SUCCESS

} from '../actions/appealActions'

const initialState = {
  clearRichField: false,
  loading: false,
  data: {
    completed_driver_details: false,
    completed_appeal_grounds: false,
    completed_appeal_detail: false
  },
  token: null,
  reasons: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case NEW_TOKEN:
      return {
        ...state,
        token: action.data
      }
    case APPEAL_LOADED:
      return {
        ...state,
        data: action.data,
        error: null,
        loading: false
      }
    case APPEAL_NOT_LOADED:
      return {
        ...state,
        error: action.error,
        loading: false
      }

    case APPEAL_LOGOUT:
      return {
        ...state,
        data: [],
        error: null,
        loading: false
      }

    case REGISTER_PENDING:
      return {
        ...state,
        register_error: null,
        register_loading: true,
        register_data: action.data
      }
    case REGISTER_SUCCESS:
      return {
        ...state,
        data: [],
        register_error: null,
        register_loading: false
      }
    case REGISTER_FAIL:
      return {
        ...state,
        register_error: action.error,
        register_loading: false
      }
    case LOGIN_PENDING:
      return {
        ...state,
        login_error: null,
        login_loading: true,
        login_data: action.data
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        login_error: null,
        login_loading: false
      }
    case LOGIN_FAIL:
      return {
        ...state,
        login_error: action.error,
        login_loading: false
      }

    case UPDATE_SUCCESS:
      return {
        ...state,
        data: action.data,
        error: null,
        loading: false,
        appealDetail_loading: false,
        details_loading: false,
        grounds_loading: false
      }
    case UPDATE_PENDING:
      return {
        ...state,
        error: null,
        loading: true,
        appealDetail_loading: (action.id === 'appealDetail'),
        details_loading: (action.id === 'details'),
        grounds_loading: (action.id === 'grounds')
      }
    case UPDATE_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false,
        appealDetail_loading: false,
        details_loading: false,
        grounds_loading: false

      }

    case DANDS_SUCCESS:
      return {
        ...state,
        data: action.data,
        dands_loading: false
      }
    case DANDS_PENDING:
      return {
        ...state,
        error: null,
        dands_loading: true
      }
    case DANDS_FAIL:
      return {
        ...state,
        error: action.error,
        dands_loading: false

      }

    case FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        error: null,
        upload_loading: false
      }
    case FILE_UPLOAD_PENDING:
      return {
        ...state,
        error: null,
        upload_loading: true
      }
    case FILE_UPLOAD_FAIL:
      return {
        ...state,
        error: action.error,
        upload_loading: false
      }
    case CREATE_REPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        submitting: false

      }
    case CREATE_REPLY_PENDING:
      return {
        ...state,
        submitting: true,
        loading: true
      }
    case GET_REASONS_SUCCESS:
      return {
        ...state,
        reasons: action.data
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/appealReducers.js